/* Silent Impact — soft page interactions */
(function () {
  'use strict';

  /* ---- Gallery: thumb switching + swipe + arrows + dots ---- */
  function siGalleryThumbs() {
    return Array.prototype.slice.call(document.querySelectorAll('.si-soft .thumbs .thumb'));
  }

  function siGalleryShow(i) {
    var thumbs = siGalleryThumbs();
    if (!thumbs.length) return;
    i = ((i % thumbs.length) + thumbs.length) % thumbs.length;
    var stage = document.getElementById('stageImg');
    var img = thumbs[i].querySelector('img');
    if (stage && img) {
      stage.src = img.src;
      stage.classList.remove('si-fade');
      void stage.offsetWidth;
      stage.classList.add('si-fade');
    }
    thumbs.forEach(function (x) { x.classList.remove('active'); });
    thumbs[i].classList.add('active');
    var dots = document.querySelectorAll('.si-soft .stage .si-dots span');
    dots.forEach(function (d, k) { d.classList.toggle('on', k === i); });
  }

  window.siGalleryGo = function (dir) {
    var thumbs = siGalleryThumbs();
    if (!thumbs.length) return;
    var cur = 0;
    thumbs.forEach(function (t, k) { if (t.classList.contains('active')) cur = k; });
    siGalleryShow(cur + dir);
  };

  function initGallery() {
    var stage = document.getElementById('stageImg');
    var thumbs = siGalleryThumbs();
    if (!stage || !thumbs.length) return;

    thumbs.forEach(function (t, i) {
      t.addEventListener('click', function () { siGalleryShow(i); });
    });

    var stageWrap = stage.closest('.stage');
    if (stageWrap) {
      var prev = document.createElement('button');
      prev.type = 'button';
      prev.className = 'si-nav si-prev';
      prev.setAttribute('aria-label', 'Previous image');
      prev.innerHTML = '&#8249;';
      prev.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); window.siGalleryGo(-1); });

      var next = document.createElement('button');
      next.type = 'button';
      next.className = 'si-nav si-next';
      next.setAttribute('aria-label', 'Next image');
      next.innerHTML = '&#8250;';
      next.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); window.siGalleryGo(1); });

      stageWrap.appendChild(prev);
      stageWrap.appendChild(next);

      /* Update the hint label to match the new tap-to-enlarge behaviour */
      var zoomEl = stageWrap.querySelector('.zoom');
      if (zoomEl) zoomEl.innerHTML = '&#128269; Tap to zoom';

      var dots = document.createElement('div');
      dots.className = 'si-dots';
      thumbs.forEach(function (t, k) {
        var d = document.createElement('span');
        if (t.classList.contains('active')) d.classList.add('on');
        d.addEventListener('click', function (e) { e.stopPropagation(); siGalleryShow(k); });
        dots.appendChild(d);
      });
      stageWrap.appendChild(dots);

      /* Touch swipe (left / right) + tap to open lightbox */
      var x0 = null, y0 = null, t0 = 0, moved = false;
      stageWrap.addEventListener('touchstart', function (e) {
        if (e.touches.length !== 1) return;
        x0 = e.touches[0].clientX;
        y0 = e.touches[0].clientY;
        t0 = Date.now();
        moved = false;
      }, { passive: true });

      stageWrap.addEventListener('touchmove', function () {
        if (x0 !== null) moved = true;
      }, { passive: true });

      stageWrap.addEventListener('touchend', function (e) {
        if (x0 === null) return;
        var t = e.changedTouches[0];
        var dx = t.clientX - x0;
        var dy = t.clientY - y0;
        var dt = Date.now() - t0;
        x0 = null;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.2 && dt < 800) {
          window.siGalleryGo(dx < 0 ? 1 : -1);
        } else if (!moved && dt < 400) {
          window.siOpenLightbox();
        }
      }, { passive: true });

      /* Mouse drag (desktop) + click to open */
      var mx0 = null, my0 = null, dragging = false, dragged = false;
      stageWrap.addEventListener('mousedown', function (e) {
        if (e.button !== 0) return;
        mx0 = e.clientX; my0 = e.clientY; dragging = true; dragged = false;
      });
      stageWrap.addEventListener('mousemove', function (e) {
        if (!dragging) return;
        if (Math.abs(e.clientX - mx0) > 6) dragged = true;
      });
      stageWrap.addEventListener('mouseup', function (e) {
        if (!dragging) return;
        dragging = false;
        var dx = e.clientX - mx0;
        var dy = e.clientY - my0;
        mx0 = null;
        if (Math.abs(dx) > 60 && Math.abs(dx) > Math.abs(dy) * 1.2) {
          window.siGalleryGo(dx < 0 ? 1 : -1);
        } else if (!dragged) {
          window.siOpenLightbox();
        }
      });
      stageWrap.addEventListener('mouseleave', function () { dragging = false; mx0 = null; });
    }

    /* Keyboard arrows (only when lightbox closed) */
    document.addEventListener('keydown', function (e) {
      if (document.body.classList.contains('si-lb-open')) return;
      var tag = (e.target && e.target.tagName) || '';
      if (tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT') return;
      if (e.key === 'ArrowLeft') window.siGalleryGo(-1);
      else if (e.key === 'ArrowRight') window.siGalleryGo(1);
    });
  }

  /* ---- Lightbox: tap to enlarge + pinch / scroll / double-tap zoom ---- */
  var lb = null, lbScale = 1, lbTx = 0, lbTy = 0;
  var lbPinchStart = 0, lbPinchScale = 1;
  var lbPanX = null, lbPanY = null, lbPanTx = 0, lbPanTy = 0;
  var lbLastTap = 0, lbSwipeX = null, lbSwipeY = null;

  /* Force the lightbox image to letterbox. Inline styles win over any
     stylesheet rule, including stale cached copies of si-soft-page.css. */
  function lbFit() {
    if (!lb) return;
    var img = lb.querySelector('.si-lb-img');
    if (!img) return;
    var small = window.innerWidth <= 560;
    img.style.setProperty('width', 'auto', 'important');
    img.style.setProperty('height', 'auto', 'important');
    img.style.setProperty('min-width', '0', 'important');
    img.style.setProperty('min-height', '0', 'important');
    img.style.setProperty('max-width', (small ? '96vw' : '94vw'), 'important');
    img.style.setProperty('max-height', (small ? '78vh' : '86vh'), 'important');
    img.style.setProperty('object-fit', 'contain', 'important');
    img.style.setProperty('object-position', 'center center', 'important');
    img.style.setProperty('flex', '0 0 auto', 'important');
    img.style.setProperty('align-self', 'center', 'important');
  }

  function lbApply() {
    if (!lb) return;
    var img = lb.querySelector('.si-lb-img');
    img.style.transform = 'translate(' + lbTx + 'px,' + lbTy + 'px) scale(' + lbScale + ')';
    lb.classList.toggle('zoomed', lbScale > 1.01);
  }

  function lbReset() {
    lbScale = 1; lbTx = 0; lbTy = 0;
    lbApply();
  }

  function lbSetScale(s, cx, cy) {
    s = Math.max(1, Math.min(5, s));
    if (cx != null && cy != null) {
      var rect = lb.querySelector('.si-lb-img').getBoundingClientRect();
      var ox = cx - (rect.left + rect.width / 2);
      var oy = cy - (rect.top + rect.height / 2);
      var k = s / lbScale;
      lbTx -= ox * (k - 1);
      lbTy -= oy * (k - 1);
    }
    lbScale = s;
    if (lbScale <= 1.01) { lbTx = 0; lbTy = 0; }
    lbApply();
  }

  function lbShow(i) {
    var thumbs = siGalleryThumbs();
    if (!thumbs.length) return;
    i = ((i % thumbs.length) + thumbs.length) % thumbs.length;
    var img = thumbs[i].querySelector('img');
    if (img) lb.querySelector('.si-lb-img').src = img.src;
    lb.dataset.index = i;
    lbFit();
    lbReset();
  }

  function lbGo(dir) {
    var i = parseInt(lb.dataset.index || '0', 10);
    lbShow(i + dir);
  }

  window.siOpenLightbox = function () {
    if (!lb) return;
    var stage = document.getElementById('stageImg');
    if (!stage) return;
    var thumbs = siGalleryThumbs();
    var cur = 0;
    thumbs.forEach(function (t, k) { if (t.classList.contains('active')) cur = k; });
    lb.querySelector('.si-lb-img').src = stage.src;
    lb.dataset.index = cur;
    lbFit();
    lbReset();
    lb.classList.add('open');
    document.body.classList.add('si-lb-open');
  };

  window.siCloseLightbox = function () {
    if (!lb) return;
    lb.classList.remove('open');
    document.body.classList.remove('si-lb-open');
    lbReset();
  };

  function initLightbox() {
    if (!document.getElementById('stageImg')) return;

    lb = document.createElement('div');
    lb.className = 'si-lightbox';
    lb.innerHTML =
      '<button type="button" class="si-lb-close" aria-label="Close">&#215;</button>' +
      '<button type="button" class="si-lb-nav si-lb-prev" aria-label="Previous">&#8249;</button>' +
      '<button type="button" class="si-lb-nav si-lb-next" aria-label="Next">&#8250;</button>' +
      '<div class="si-lb-stage"><img class="si-lb-img" alt=""></div>' +
      '<div class="si-lb-hint">Pinch or double-tap to zoom</div>';
    document.body.appendChild(lb);
    lbFit();
    window.addEventListener('resize', function () { if (lb) lbFit(); });
    window.addEventListener('orientationchange', function () { if (lb) lbFit(); });

    var stageEl = lb.querySelector('.si-lb-stage');
    var imgEl = lb.querySelector('.si-lb-img');

    lb.querySelector('.si-lb-close').addEventListener('click', function (e) { e.stopPropagation(); window.siCloseLightbox(); });
    lb.querySelector('.si-lb-prev').addEventListener('click', function (e) { e.stopPropagation(); lbGo(-1); });
    lb.querySelector('.si-lb-next').addEventListener('click', function (e) { e.stopPropagation(); lbGo(1); });

    lb.addEventListener('click', function (e) {
      if (e.target === lb || e.target === stageEl) window.siCloseLightbox();
    });

    /* wheel zoom (desktop) */
    stageEl.addEventListener('wheel', function (e) {
      e.preventDefault();
      lbSetScale(lbScale * (e.deltaY < 0 ? 1.15 : 0.87), e.clientX, e.clientY);
    }, { passive: false });

    /* double-click zoom (desktop) */
    stageEl.addEventListener('dblclick', function (e) {
      e.preventDefault();
      if (lbScale > 1.01) lbReset();
      else lbSetScale(2.5, e.clientX, e.clientY);
    });

    /* touch: pinch zoom, pan, double-tap zoom, swipe nav */
    stageEl.addEventListener('touchstart', function (e) {
      if (e.touches.length === 2) {
        lbPinchStart = Math.hypot(
          e.touches[0].clientX - e.touches[1].clientX,
          e.touches[0].clientY - e.touches[1].clientY);
        lbPinchScale = lbScale;
      } else if (e.touches.length === 1) {
        lbPanX = e.touches[0].clientX;
        lbPanY = e.touches[0].clientY;
        lbPanTx = lbTx; lbPanTy = lbTy;
        lbSwipeX = e.touches[0].clientX;
        lbSwipeY = e.touches[0].clientY;
      }
    }, { passive: true });

    stageEl.addEventListener('touchmove', function (e) {
      if (e.touches.length === 2 && lbPinchStart) {
        e.preventDefault();
        var d = Math.hypot(
          e.touches[0].clientX - e.touches[1].clientX,
          e.touches[0].clientY - e.touches[1].clientY);
        var cx = (e.touches[0].clientX + e.touches[1].clientX) / 2;
        var cy = (e.touches[0].clientY + e.touches[1].clientY) / 2;
        lbSetScale(lbPinchScale * (d / lbPinchStart), cx, cy);
      } else if (e.touches.length === 1 && lbScale > 1.01 && lbPanX !== null) {
        e.preventDefault();
        lbTx = lbPanTx + (e.touches[0].clientX - lbPanX);
        lbTy = lbPanTy + (e.touches[0].clientY - lbPanY);
        lbApply();
      }
    }, { passive: false });

    stageEl.addEventListener('touchend', function (e) {
      if (e.touches.length === 0) {
        var now = Date.now();
        var t = e.changedTouches[0];
        var dx = t.clientX - lbSwipeX;
        var dy = t.clientY - lbSwipeY;
        var isTap = Math.abs(dx) < 12 && Math.abs(dy) < 12;
        if (isTap) {
          /* double-tap toggles zoom (works at any scale) */
          if (now - lbLastTap < 300) {
            if (lbScale > 1.01) lbReset();
            else lbSetScale(2.5, t.clientX, t.clientY);
            lbLastTap = 0;
          } else {
            lbLastTap = now;
          }
        } else if (lbScale <= 1.01 && Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy) * 1.2) {
          /* swipe navigates only when not zoomed */
          lbGo(dx < 0 ? 1 : -1);
        }
        lbPinchStart = 0;
        lbPanX = null;
      } else if (e.touches.length === 1) {
        lbPanX = e.touches[0].clientX;
        lbPanY = e.touches[0].clientY;
        lbPanTx = lbTx; lbPanTy = lbTy;
        lbPinchStart = 0;
      }
    }, { passive: true });

    document.addEventListener('keydown', function (e) {
      if (!lb.classList.contains('open')) return;
      if (e.key === 'Escape') window.siCloseLightbox();
      else if (e.key === 'ArrowLeft') lbGo(-1);
      else if (e.key === 'ArrowRight') lbGo(1);
    });
  }

  /* ---- Countdown timer ---- */
  function initCountdown() {
    var h = document.getElementById('cd-h');
    var m = document.getElementById('cd-m');
    var s = document.getElementById('cd-s');
    if (!h || !m || !s) return;
    var total = 5 * 3600 + 42 * 60 + 18;
    function tick() {
      if (total < 0) total = 5 * 3600 + 42 * 60 + 18;
      var hh = Math.floor(total / 3600);
      var mm = Math.floor((total % 3600) / 60);
      var ss = total % 60;
      h.textContent = String(hh).padStart(2, '0');
      m.textContent = String(mm).padStart(2, '0');
      s.textContent = String(ss).padStart(2, '0');
      total--;
    }
    tick();
    setInterval(tick, 1000);
  }

  /* ---- Toast ---- */
  window.siToast = function (msg) {
    var t = document.getElementById('toast');
    if (!t) return;
    t.textContent = msg;
    t.classList.add('show');
    clearTimeout(window.__siToastTimer);
    window.__siToastTimer = setTimeout(function () { t.classList.remove('show'); }, 2600);
  };

  /* ---- Copy discount code ---- */
  window.siCopyCode = function () {
    var code = 'SILENT10';
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(code).then(function () {
        window.siToast('Code ' + code + ' copied!');
      }).catch(function () { window.siToast('Code: ' + code); });
    } else {
      window.siToast('Code: ' + code);
    }
  };

  /* ---- Variant / colour swatch selection ---- */
  window.siSelectVariant = function (el) {
    var wrap = el.closest('.variant');
    if (!wrap) return;
    var opts = wrap.querySelectorAll('.v-opt');
    opts.forEach(function (o) { o.classList.remove('active'); });
    el.classList.add('active');

    var label = wrap.querySelector('.v-label span');
    if (label && el.getAttribute('data-label')) label.textContent = el.getAttribute('data-label');

    var img = el.getAttribute('data-img');
    if (img) {
      var stage = document.getElementById('stageImg');
      if (stage) stage.src = img;
      var thumbs = document.querySelectorAll('.si-soft .thumbs .thumb');
      if (thumbs.length) {
        var firstImg = thumbs[0].querySelector('img');
        if (firstImg) firstImg.src = img;
        thumbs.forEach(function (t) { t.classList.remove('active'); });
        thumbs[0].classList.add('active');
      }
      var dots = document.querySelectorAll('.si-soft .stage .si-dots span');
      dots.forEach(function (d, k) { d.classList.toggle('on', k === 0); });
    }

    var vid = el.getAttribute('data-variant');
    if (vid) {
      document.querySelectorAll('.si-soft .si-add').forEach(function (b) {
        var f = b.closest('form');
        if (f) {
          var inp = f.querySelector('input[name="id"]');
          if (inp) inp.value = vid;
          b.removeAttribute('onclick');
        } else {
          b.setAttribute('onclick', "window.location.href='https://silentimpactstore.com/cart/add?id=" + vid + "&quantity=" + (window.siQty||1) + "'");
        }
      });
      document.querySelectorAll('.si-soft .si-buy').forEach(function (b) {
        b.setAttribute('onclick', "window.location.href='https://silentimpactstore.com/cart/" + vid + ":" + (window.siQty||1) + "?checkout'");
      });
      document.querySelectorAll('.si-soft .si-express-form input[name="id"]').forEach(function (inp) { inp.value = vid; });
    }
  };

  /* ---- Dropdown navigation (clickable) ---- */
  window.siToggleDrop = function (btn) {
    var item = btn.closest('.nav-item');
    if (!item) return;
    var wasOpen = item.classList.contains('open');
    document.querySelectorAll('.si-soft .nav-item.open').forEach(function (x) { x.classList.remove('open'); });
    if (!wasOpen) item.classList.add('open');
  };

  /* ---- Mobile hamburger ---- */
  window.siToggleNav = function (btn) {
    var nav = document.getElementById('siNav');
    if (!nav) return;
    nav.classList.toggle('open');
  };

  /* ---- Close dropdowns on outside click / escape ---- */
  document.addEventListener('click', function (e) {
    if (!e.target.closest('.si-soft .nav-item') && !e.target.closest('.si-soft .nav-toggle')) {
      document.querySelectorAll('.si-soft .nav-item.open').forEach(function (x) { x.classList.remove('open'); });
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      document.querySelectorAll('.si-soft .nav-item.open').forEach(function (x) { x.classList.remove('open'); });
      var nav = document.getElementById('siNav');
      if (nav) nav.classList.remove('open');
    }
  });

  /* ---- Live cart count ---- */
  function updateCartCount() {
    var el = document.getElementById('siCartCount');
    if (!el) return;
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { el.textContent = cart.item_count || 0; })
      .catch(function () {});
  }

  function init() {
    initGallery();
    initLightbox();
    initCountdown();
    updateCartCount();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();


/* ---- Nail trimmer colour selector (added) ---- */
(function () {
  function apply(opt) {
    if (!opt) return;
    var vid = opt.getAttribute('data-vid');
    var label = opt.getAttribute('data-label') || (opt.textContent || '').trim();
    document.querySelectorAll('.v-opt').forEach(function (o) {
      o.classList.remove('active');
      o.setAttribute('aria-pressed', 'false');
    });
    opt.classList.add('active');
    opt.setAttribute('aria-pressed', 'true');
    var lbl = document.getElementById('ntColorLabel');
    if (lbl) lbl.textContent = label;
    var hid = document.getElementById('ntVariantId');
    if (hid) hid.value = vid;
    var buy = document.getElementById('ntBuyBtn');
    if (buy) buy.setAttribute('data-vid', vid);
    var fin = document.getElementById('ntFinalBtn');
    if (fin) fin.setAttribute('data-vid', vid);
  }

  window.siSelectNt = function (el) { apply(el); };

  window.siCurrentVariant = function () {
    var hid = document.getElementById('ntVariantId');
    return hid && hid.value ? hid.value : '51669148795047';
  };

  window.siBuyNow = function () {
    window.location.href = '/cart/' + window.siCurrentVariant() + ':1?checkout';
  };

  window.siAddFinal = function () {
    window.location.href = '/cart/' + window.siCurrentVariant() + ':1';
  };

  function init() {
    var opts = document.querySelectorAll('.v-opt[data-vid]');
    if (!opts.length) return;
    apply(document.querySelector('.v-opt.active') || opts[0]);
    opts.forEach(function (o) {
      o.setAttribute('role', 'button');
      o.setAttribute('tabindex', '0');
      o.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); apply(o); }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else { init(); }
})();


/* ---- Breast pump set selector (added) ---- */
(function () {
  function money(n) { return '$' + Number(n).toFixed(2); }

  window.siSelectPump = function (el) {
    if (!el) return;
    var wrap = el.closest('.variant');
    if (wrap) {
      wrap.querySelectorAll('.v-opt').forEach(function (o) {
        o.classList.remove('active');
        o.setAttribute('aria-pressed', 'false');
      });
    }
    el.classList.add('active');
    el.setAttribute('aria-pressed', 'true');

    var vid    = el.getAttribute('data-vid');
    var label  = el.getAttribute('data-label') || '';
    var price  = el.getAttribute('data-price');
    var comp   = el.getAttribute('data-compare');
    var save   = el.getAttribute('data-save');

    var lbl = document.getElementById('pumpSetLabel');
    if (lbl) lbl.textContent = label;

    var pEl = document.querySelector('.si-soft .price-row .price');
    if (pEl && price) pEl.textContent = money(price);
    var cEl = document.querySelector('.si-soft .price-row .price-compare');
    if (cEl && comp) cEl.textContent = money(comp);
    var sEl = document.querySelector('.si-soft .price-row .price-save');
    if (sEl && save) sEl.textContent = save;

    document.querySelectorAll('.si-soft .si-add-form input[name="id"]').forEach(function (i) { i.value = vid; });

    ['pumpAddBtn', 'pumpFinalBtn'].forEach(function (id) {
      var b = document.getElementById(id);
      if (b && price) b.textContent = 'Add to Cart \u2014 ' + money(price);
    });

    var buy = document.getElementById('pumpBuyBtn');
    if (buy) buy.setAttribute('onclick', "window.location.href='/cart/" + vid + ":1?checkout'");
  };

  function init() {
    var opts = document.querySelectorAll('.v-opt[data-vid]');
    if (!opts.length) return;
    var act = document.querySelector('.v-opt.active[data-vid]');
    if (act) window.siSelectPump(act);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
